import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
const Header = () => {
  return (
    <header>
      <div className="header_wrapper">
        <div className="row mx-0">
          <div className="col-lg-12 px-0">
            <Splide
              className="dir_ltr"
              aria-label="My Favorite Images"
              options={{
                rewind: true,
                type: "loop",
                arrows: false,
                autoplay: true,
                interval: 10000,
                drag: true,
                easing: "ease",
              }}
            >
              <SplideSlide>
                <img
                  src="/images/long-scroll-websites-408ffd88656f7355c3a6f13eec10a791.png"
                  alt="Image 1"
                  className="img-fluid header_img"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="/images/company2.jpg"
                  alt="Image 2"
                  className="img-fluid header_img"
                />
              </SplideSlide>
            </Splide>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
